module.exports = __webpack_public_path__ + "img/sekerBottom.00e60c15.jpg";